import "./Media.css.ts.vanilla.css.mjs";
var e = "p295__Media-937c_ceb34e2__15utp8l4", p = "p295__Media-937c_ceb34e2__15utp8l9", a = "p295__Media-937c_ceb34e2__15utp8l8", c = "p295__Media-937c_ceb34e2__15utp8l3", i = { large: "p295__Media-937c_ceb34e2__15utp8l0", medium: "p295__Media-937c_ceb34e2__15utp8l1", small: "p295__Media-937c_ceb34e2__15utp8l2" }, l = "p295__Media-937c_ceb34e2__15utp8la", d = { bigVideo: "p295__Media-937c_ceb34e2__bigVideo__15utp8l5", smallVideo: "p295__Media-937c_ceb34e2__smallVideo__15utp8l6" }, t = "p295__Media-937c_ceb34e2__15utp8l7", u = "p295__Media-937c_ceb34e2__15utp8lc";
export {
  e as icon,
  p as img,
  a as pic,
  c as playBtn,
  i as sizeMap,
  l as video,
  d as videoBtn,
  t as youtubeBtn,
  u as youtubeImg
};
//# sourceMappingURL=Media.css.mjs.map
